function dateFormat(date, format = "YYYY-MM-DD") {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  const dateConfig = {
    "(Y|y)+": date.getFullYear(),
    // 月份
    "M+": date.getMonth() + 1,
    // 月份
    "(d|D)+": date.getDate(),
    // 日
    "h+": date.getHours() > 12 ? date.getHours() - 12 : date.getHours(),
    // 小时
    "H+": date.getHours(),
    // 24小时
    "m+": date.getMinutes(),
    // 分
    "s+": date.getSeconds(),
    // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3),
    // 季度
    "S+": date.getMilliseconds()
    // 毫秒
  };
  Object.keys(dateConfig).forEach((key) => {
    if (new RegExp(key).test(format)) {
      format = format.replace(new RegExp("(" + key + ")"), function(match) {
        if (match.length > String(dateConfig[key]).length) {
          return new Array(match.length - String(dateConfig[key]).length).fill("0").join("") + String(dateConfig[key]);
        }
        return String(dateConfig[key]);
      });
    }
  });
  return format;
}
function timeDifferenceFormat(date, separator = "/") {
  const currentTime = /* @__PURE__ */ new Date(), compareTime = new Date(date);
  const timeDifference = (currentTime.getTime() - compareTime.getTime()) / 1e3;
  if (timeDifference < 60) {
    return "\u521A\u521A\u4E4B\u524D";
  } else if (timeDifference < 3600) {
    return parseInt(String(timeDifference / 60), 10) + "\u5206\u949F\u524D";
  } else if (timeDifference < 60 * 60 * 24) {
    return parseInt(String(timeDifference / 3600), 10) + "\u5C0F\u65F6\u524D";
  } else if (timeDifference < 60 * 60 * 24 * 30) {
    return parseInt(String(timeDifference / (60 * 60 * 24)), 10) + "\u5929\u524D";
  } else if (compareTime.getFullYear() === currentTime.getFullYear()) {
    return dateFormat(compareTime, `MM${separator}DD`);
  }
  return dateFormat(compareTime, `YYYY${separator}MM${separator}DD`);
}
function numberFormat(value, digit = 0) {
  if (typeof value === "string") {
    value = value.replace(/\$|,/g, "");
    value = parseFloat(value);
  }
  if (digit < 0) {
    digit = 0;
  } else if (digit > 11) {
    throw new Error("\u6700\u5927\u652F\u630111\u4F4D\u5C0F\u6570\u683C\u5F0F\u5316");
  }
  value = value.toFixed(digit);
  if (value.indexOf(".") === -1) {
    value = value.replace(/\B(?=(?:\d{3})+$)/g, ",");
  } else {
    value = value.substring(0, value.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ",") + value.substring(value.indexOf("."), value.length);
  }
  return value;
}
function stringFormat(contents, parameters) {
  if (!parameters || !contents) {
    return contents;
  }
  if (parameters.length > 0) {
    parameters.forEach((value, index) => {
      contents = contents.replace(new RegExp("\\{" + index + "\\}", "g"), value === null ? "" : value);
    });
  } else {
    Object.keys(parameters).forEach((key) => {
      contents = contents.replace(new RegExp("\\{" + key + "\\}", "g"), parameters[key] === null ? "" : parameters[key]);
    });
  }
  return contents;
}

export { dateFormat, numberFormat, stringFormat, timeDifferenceFormat };
//# sourceMappingURL=format.mjs.map
